import { API_CONFIG } from '../config/index';

export const API_BASE = {
    // Base URL for the API requests
    API_BASE_URL: API_CONFIG.BASE_URL,
    
    // API Endpoints
    ENDPOINTS: API_CONFIG.ENDPOINTS
};

